import { Component, OnInit, Input } from '@angular/core';
import {ProgressbarWithCircleConfigurations} from './progressbar-with-circle.configurations';
import { CommonModule } from '@angular/common';
import { TitleComponent } from '../title/title.component';
import { SimpleCircleChartComponent } from 'app/shared/charts/simple-circle-chart/simple-circle-chart.component';
import { SimpleProgressbarComponent } from 'app/shared/charts/simple-progressbar/simple-progressbar.component';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-progressbar-with-circle-chart',
  templateUrl: './progressbar-with-circle-chart.component.html',
  styleUrls: ['./progressbar-with-circle-chart.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent, SimpleCircleChartComponent, SimpleProgressbarComponent, DynamicContentComponent ]
})
export class ProgressbarWithCircleChartComponent implements OnInit {

  constructor() { }

  @Input()
  public config: ProgressbarWithCircleConfigurations;

  @Input()
  public lineConfig: ProgressbarWithCircleConfigurations;

  public lineColor = '#269bc8';

  public showLineBetweenCircles = true;

  public showLineAcross = true;
  titleConfig: any;

  ngOnInit() {
    this.titleConfig = {
      header: this.config.header,
      title: this.config.title,
      badges: this.config.badges
    };
    if (this.config.showLineBetweenCircles) {
       this.showLineBetweenCircles = this.config.showLineBetweenCircles;
    }

    if (this.config.showLineAcross) {
       this.showLineAcross = this.config.showLineAcross;
    }
  }

  public generateConfig(value: any, circleText: string) {
    return {
      value: value,
      circleText: circleText,
      width: 125,
      height: 125,
      colorPercent: '#000000',
      colorBackground: '#e2e2e2',
      colorCircle: '#f3f4f6',
      colorForeground: this.config.foregroundColor,
    };
  }

}
